export const myGiftCards = (state) => state.myGiftCards
export const isLoading = (state) => state.loading
export const giftCards = (state) => state.giftCards
export const detailLoading = (state) => state.detailLoading
export const myActiveGiftCards = (state) => state.myActiveGiftCards
export const useGiftCardForCheckout = (state) => state.useGiftCardForCheckout
export const isCurrencyInputFocused = (state) => state.isCurrencyInputFocused

// Getter with parameter
export const giftCardDetailByID = (state) => (id) =>
  state.giftCardDetails[id] || null

// Complex getters with logic
export const selectedGiftCardForCheckout = (state, getters) => {
  const selected = state.selectedGiftCardForCheckout || {}
  return Object.keys(selected).length
    ? selected // Return selected if not empty
    : Object.fromEntries(Object.entries(getters.myActiveGiftCards).slice(0, 2)) // Otherwise get first 2 active cards
}

export const selectedExternalGiftCardForCheckout = (state) =>
  state.selectedExternalGiftCardForCheckout || {}

export const totalRedeemAmount = (state, getters) => {
  const allCards = [
    ...Object.values(getters.selectedGiftCardForCheckout),
    ...Object.values(getters.selectedExternalGiftCardForCheckout),
  ]

  const redeemAmount = allCards.reduce(
    (total, card) => total + (Number(card.redeemAmount) || 0),
    0
  )
  return Number(redeemAmount.toFixed(2)) || 0
}
